import { motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { Reveal } from "./Reveal";

const placeholders = [
  { city: "To Be Announced", note: "New dates dropping soon" },
  { city: "To Be Announced", note: "New dates dropping soon" },
  { city: "To Be Announced", note: "New dates dropping soon" },
];

export default function UpcomingShows() {
  return (
    <section className="relative bg-[#0d0d0d] py-24 md:py-36 border-t border-white/10" data-testid="upcoming-shows">
      <div className="absolute inset-0 pointer-events-none" aria-hidden style={{ background: "radial-gradient(circle at 20% 20%, rgba(79,176,74,0.10), transparent 55%)" }} />
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-12 md:mb-16">
          <p className="overline text-gold mb-6">On The Road</p>
          <h2 className="headline text-5xl md:text-7xl text-white mb-6">Upcoming Shows</h2>
          <p className="font-body text-white/55 text-lg leading-relaxed">
            The next run of dates is being locked in. Check back soon, or follow along on Instagram to be first to know.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {placeholders.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`upcoming-show-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="relative bg-[#0d0d0d] p-8 md:p-10 flex flex-col gap-4 overflow-hidden"
            >
              <span className="inline-flex items-center gap-2 self-start font-display uppercase tracking-[0.18em] text-[0.6rem] px-3 py-1 rounded-full border border-gold/50 text-gold">
                Coming Soon
              </span>
              <div className="flex items-center gap-4">
                <CalendarClock className="text-white/25" size={30} />
                <div>
                  <p className="font-display uppercase tracking-[0.08em] text-lg text-white/85">{p.city}</p>
                  <p className="font-body text-sm text-white/45 mt-1">{p.note}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-white/10">
          <p className="font-body text-white/45 text-sm md:text-[0.95rem] leading-relaxed max-w-4xl" data-testid="nonprofit-note">
            Net proceeds from Timbaland Way events, ticket sales, and fundraising initiatives directly benefit the
            mission and community programs of Timbaland Way Cares, a registered 501(c)(3) nonprofit organization.
          </p>
        </div>
      </div>
    </section>
  );
}
